import { Wrapper } from './style'

interface QuantityProps {
    value: number
    size: 'big' | 'small'
}

const Quantity = ({ value, size }: QuantityProps) => (
    <Wrapper size={size}>{value}x</Wrapper>
)

export default Quantity
